var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"list-item",on:{"touchend":function($event){_vm.linkWhere(_vm.itemData.id)}}},[_vm._v("\n    "+_vm._s(_vm.itemData.title)+"\n    "+_vm._s(_vm._f("parseTime")(_vm.itemData.add_time,'{y}-{m}-{d}'))+"\n    "),_c('span',{staticClass:"more"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-164051f7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/listItem.vue
// module id = null
// module chunks = 